import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Inner, Spinner, Text } from "./styles/widget-loading-styles";
import spinner from "./img/loading.gif";

const WidgetLoading = ({ opacity, text, zIndex }) => (
  <Wrapper opacity={opacity} zIndex={zIndex} data-test-id="widget-loading">
    <Inner>
      <Spinner
        src={spinner}
        alt="Sending spinner"
        data-test-id="loading-widget-spinner"
      />
      {text && <Text>{text}</Text>}
    </Inner>
  </Wrapper>
);

WidgetLoading.propTypes = {
  opacity: PropTypes.number,
  text: PropTypes.string,
  zIndex: PropTypes.number,
};

WidgetLoading.defaultProps = {
  opacity: PropTypes.isNull,
  text: PropTypes.isNull,
  zIndex: PropTypes.isNull,
};

export default WidgetLoading;
